import { initialiseSentry } from "@/lib/sentry";
initialiseSentry();

import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const storedTheme = localStorage.getItem('alphasignal-theme');
const theme = storedTheme ?? 'light';
if (theme === 'dark') {
  document.documentElement.classList.add('dark');
} else {
  document.documentElement.classList.remove('dark');
}
if (!storedTheme) {
  localStorage.setItem('alphasignal-theme', 'light');
}

createRoot(document.getElementById('root')!).render(<App />);
